module.exports = __webpack_public_path__ + "static/media/Banner_categorias.36f73e37.jpg";